import Vue from 'vue';

class PermissionsService
{
    static async getList()
    {
        return Vue.axios.get('admin/permissions');
    }

    static async addContent(page)
    {
        return Vue.axios.post(`admin/permissions`, page);
    }

    static async updateContent(id, model)
    {
        return Vue.axios.put(`admin/permissions/${id}`, model);
    }

    static async deleteContent(id)
    {
        return Vue.axios.delete(`admin/permissions/${id}`);
    }
}

export default PermissionsService;
